const uniArticles = [
  {
    title: "Columbia has appointed three woman presidents in two years. Experts vary on whether there is a ‘glass cliff’ in the University’s highest office.",
    author: "Joseph Zuloaga",
    articleLink: "https://www.columbiaspectator.com/news/2025/10/13/columbia-has-appointed-three-woman-presidents-in-two-years-experts-vary-on-whether-there-is-a-glass-cliff-in-the-universitys-highest-office/",
    image: "https://www.columbiaspectator.com/resizer/v2/UJTBI7YA4NBV7B3DJETNNNHI3Q.png?auth=bd75013f3b53c1aa087b1c0a8e40ec5e291fcc0f9f242937b9128fe4bf967c16"
  },
  {
    title: "Li Lu, CC ’96, Business ’96, Law ’96, gifts $15 million for Law School Library renovation after previous donor withdraws",
    author: "Theresa Cullen",
    articleLink: "https://www.columbiaspectator.com/news/2025/10/14/li-lu-cc-96-business-96-law-96-gifts-15-million-for-law-school-library-renovation-after-previous-donor-withdraws/",
    image: "https://www.columbiaspectator.com/resizer/v2/33ODBNH4YZDFJBMRYPMMAR3MYU.jpg?auth=77877f1668d7b7a7b14e232867d541fcbc0e267e4cd09d7e7e44adf5913bd5f9"
  },
  {
    title: "Akilah Rosado, Barnard’s new vice president for inclusion and belonging, wants to listen",
    author: "Theresa Cullen",
    articleLink: "https://www.columbiaspectator.com/news/2025/10/14/akilah-rosado-barnards-new-vice-president-for-inclusion-and-belonging-wants-to-listen/",
    image: "https://www.columbiaspectator.com/resizer/v2/7PAHNYOD7JGTRHYDNBVYAMU4NE.jpg?auth=21c5c126656d8eb12cabb7f443b7b4daa4dcfff9327d1b757d756d5a1ce46ec1"
  },
  {
    title: "International Student Hardship Fund disburses nearly $500,000 to international students in span of six months",
    author: "Emily Pickering",
    articleLink: "https://www.columbiaspectator.com/news/2025/10/12/international-student-hardship-fund-disburses-nearly-500000-to-international-students-in-span-of-six-months/",
    image: "https://www.columbiaspectator.com/resizer/v2/M5HTVPTRPNE3ZKZXLP2RSWYQDE.jpg?auth=eebba10fdf33d0bb5d64e3c92299043701f06b541a677ec75957e777831a7857"
  },
  {
    title: "As Columbia moves to embrace institutional neutrality, here is how the University has historically responded to global and national events",
    author: "Celine Chien",
    articleLink: "https://www.columbiaspectator.com/news/2025/10/13/as-columbia-moves-to-embrace-institutional-neutrality-here-is-how-the-university-has-historically-responded-to-global-and-national-events/",
    image: "https://www.columbiaspectator.com/resizer/v2/H4PMPCBJR5FOLHESGKNJB3VPX4.png?auth=8270e18159bd578e83013717aac46df1aecc59a2a1bb45c70b3d80d4cbedd487"
  }
];
export default uniArticles;